import { useMemo } from "react"
import {
  TreatmentPlanTemplateStoreData,
  useTreatmentPlanTemplatesStoreContext,
} from "@/modules/patients/services/fetchTreatmentPlanTemplates"
import { Language } from "@/types/__generated__/union-types"

function useTreatmentPlanTemplatesData(key: Language) {
  const treatmentPlanTemplates = useTreatmentPlanTemplatesStoreContext((state) => state.treatmentPlanTemplates)
  const treatmentPlanTemplate = useMemo<TreatmentPlanTemplateStoreData[] | null>(():
    | TreatmentPlanTemplateStoreData[]
    | null => {
    if (treatmentPlanTemplates) {
      const treatmentPlanTemplatesData = treatmentPlanTemplates.get(key)
      return treatmentPlanTemplatesData ?? null
    }
    return null
  }, [key, treatmentPlanTemplates])

  return treatmentPlanTemplate
}

export { useTreatmentPlanTemplatesData }
